import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const risorseGuard: CanActivateFn = (route, state) => {
  const router = inject(Router)

  const risorseSidenav: RisorseDTO[] = JSON.parse(sessionStorage.getItem('listIdRisorseSidenav')!);
  const risorseUtenze = (route.data['idSidenav'] as string[])[0];

  if (!risorseSidenav?.some((risorsa) => risorsa.idRisorsa == risorseUtenze)) {
    router.navigate(['./home'])
    return false
  } else return true
};

interface RisorseDTO {
  PERMESSO_OP: string;
  idRisorsa: string;
}